// extracted by mini-css-extract-plugin
export default {"root":"appearance_root__tVJo-","active":"appearance_active__2ZUor"};